/*
 * Share USP row (Kt) — turns a USP row with the share icon into a share button on the 2026 PDP.
 * Native share sheet where the browser has one, clipboard copy everywhere else.
 */
if (!customElements.get('kt-share-usp')) {
  customElements.define(
    'kt-share-usp',
    class KtShareUsp extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.kt-usp__share');
        this.message = this.querySelector('.kt-usp__share-message');
        if (!this.trigger || this.bound) return;
        this.bound = true;
        this.trigger.addEventListener('click', this.share.bind(this));
      }

      // The canonical product URL, plus whichever variant is being looked at now — the address bar
      // also carries utm/click ids we do not want to hand round.
      get shareUrl() {
        const base = this.dataset.shareUrl;
        if (!base) return window.location.href;
        const variant = new URLSearchParams(window.location.search).get('variant');
        return variant ? `${base}${base.includes('?') ? '&' : '?'}variant=${variant}` : base;
      }

      async share() {
        const url = this.shareUrl;

        if (navigator.share) {
          try {
            await navigator.share({ title: this.dataset.shareTitle || document.title, url });
            return;
          } catch (error) {
            // Dismissing the share sheet throws too, and that is not worth a fallback.
            if (error && error.name === 'AbortError') return;
          }
        }

        this.copy(url);
      }

      async copy(url) {
        try {
          await navigator.clipboard.writeText(url);
        } catch (error) {
          if (!this.copyFallback(url)) return;
        }
        this.confirm();
      }

      // clipboard.writeText needs a secure context; older in-app browsers get the select-and-copy route.
      copyFallback(url) {
        const field = document.createElement('textarea');
        field.value = url;
        field.setAttribute('readonly', '');
        field.style.cssText = 'position:absolute;left:-9999px;top:0;';
        document.body.appendChild(field);
        field.select();
        let copied = false;
        try {
          copied = document.execCommand('copy');
        } catch (error) {
          copied = false;
        }
        document.body.removeChild(field);
        return copied;
      }

      confirm() {
        if (!this.message) return;
        this.message.hidden = false;
        clearTimeout(this.messageTimer);
        this.messageTimer = setTimeout(() => {
          this.message.hidden = true;
        }, 3000);
      }
    }
  );
}
